import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsProductCatalogueResponse {
  items: AnvaProduct[];
  count: number;
}
export interface AnvaProduct {
  id: string;
  anva_id: string;
  name: string;
  insurance: Insurance;
  insurance_company: Insurance_company;
  coverages: CoveragesItem[];
}
interface Insurance {
  id: string;
  name: string;
  company: string;
  type: string;
  options: string[];
  affinity: string;
}
interface Insurance_company {
  id: string;
  name: string;
  code: string;
  form: string;
}
interface CoveragesItem {
  id: string;
  risk_object: string;
  insurance_product_ids: string[];
  insurance_company: string;
  premium: number;
  payment_interval: string;
  insured_value: number;
  deductible: string;
  description: string;
  name: string;
  due_date: string;
}

export const getAnvaFlowsProductCatalogue = async (entityType: PartyType) => {
  const { data, isError } = await wgApi.get<AnvaFlowsProductCatalogueResponse>(
    `/v1/api/anvaproducts`,
    {
      query: { entity_type: entityType },
    },
  );
  if (isError) throw new Error();
  return data;
};

const getUseAnvaProductsQKey = (entityType: PartyType) => [
  'flow-config',
  'anva',
  'products',
  entityType,
];

export const useAnvaProducts = (entityType: PartyType) => {
  if (!entityType) {
    throw new Error('entityType is required');
  }

  return useQuery(
    getUseAnvaProductsQKey(entityType),
    () => getAnvaFlowsProductCatalogue(entityType),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
